import React from 'react';
import './LoadingMessage.css';

function LoadingMessage() {
    return (
        <div className="loading-message">
            <span className="loading-dots">
                <span>.</span><span>.</span><span>.</span>
            </span>
        </div>
    );
}

export default LoadingMessage;